module.exports = __webpack_public_path__ + "img/signup-dark.dafc5deb.svg";